// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.12819"][{"5424":0}[chunkId]] || "1.12820") + "/" + chunkId + ".js";
};